var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('VideoComponent',{attrs:{"videos":_vm.items}}):(_vm.noData)?_c('div',[_c('p',[_vm._v("Материалы не найдены")])]):_c('div',[_c('i',{staticClass:"loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }